class FuelConsumptionUrlPath {
    public static BASE = "/fuelConsumption";

    public static CREATE = FuelConsumptionUrlPath.BASE + "/create";
    public static UPDATE = FuelConsumptionUrlPath.BASE + "/update";

    public static GET_BY_VEHICLE_ID = FuelConsumptionUrlPath.BASE + "/byVehicle";
}

export default FuelConsumptionUrlPath;